import React from 'react';
import ReactDOM from 'react-dom';

export async function appRender(render: () => React.ReactElement) {
	ReactDOM.render(render(), document.getElementById('root'));
}
